export function GettingRoleID(name) {
  const localStorageDetail = window.localStorage.getItem('roles');
  const roles = JSON.parse(localStorageDetail || null);
  const getRoleOFVendor = roles.find((item) => item.role === name);
  return getRoleOFVendor.id;
}
